// src/features/subject/subjectSlice.js
import { createSlice } from "@reduxjs/toolkit";

// Initialize from URL if available (for SSR/hydration)
const getInitialSubject = () => {
  if (typeof window !== "undefined") {
    const path = window.location.pathname;
    const match = path.match(/^\/([^/]+)/);
    if (match && match[1] && !["admin", "practice", "signin", "signup", "curriculum"].includes(match[1].toLowerCase())) {
      const subject = match[1].toLowerCase();
      return subject === "agenticai" ? "agentic-ai" : subject;
    }
  }
  return "fastapi"; // default
};

const subjectSlice = createSlice({
  name: "subject",
  initialState: { current: getInitialSubject() },
  reducers: {
    setSubject: (state, action) => {
      const val = action.payload;
      state.current = val?.toLowerCase() === "agenticai" ? "agentic-ai" : val; // e.g., "fastapi"
    }
  }
});

export const { setSubject } = subjectSlice.actions;
export default subjectSlice.reducer;
